

















import { Component, Mixins, Prop, Watch } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { parse, isToday } from 'date-fns'

// Mixins
import DateMixin from '@/mixins/Date'

@Component
export default class DatePicker extends Mixins(DateMixin) {
  date: string|Date = null
  active = false
  months: string[] = []
  days: string[] = []
  $refs: {
    datepicker: any
  }

  @Getter('locale', { namespace: 'user' }) locale
  @Prop({ type: Boolean, default: false }) fullWidth
  @Prop({ type: String, default: null }) inputDate
  @Prop({ type: Boolean, default: false }) now
  @Prop({ type: Date, default: null }) minDate
  @Prop({ type: Date, default: null }) maxDate

  @Watch('date')
  updateDatePicker(date) {
    this.$emit('select', date.toISOString())
    this.$refs.datepicker.toggle()
  }

  @Watch('locale', { immediate: true })
  updateLocale() {
    this.setLocale()
  }

  @Watch('inputDate', {immediate: true })
  updateDate() {
    this.date = this.inputDate ? parse(this.inputDate) : null
  }

  get isToday(): boolean {
    return isToday(this.date)
  }

  get canReset(): boolean {
    return this.date !== null
  }

  setLocale() {
    this.months  = (this.$t('global.datepicker.month_names') as string).split(',')
    this.days = (this.$t('global.datepicker.days_names') as string).split(',')
  }

  reset() {
    if (!this.canReset) {
      return
    }
    this.date = null
  }

  updateDropdownActiveClass(state) {
    this.active = state
  }

  mounted() {
    setTimeout(() => {
      if (this.$refs.datepicker.isActive) {
        this.$refs.datepicker.toggle()
      }
    }, 0)
  }
}
